<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-12
        h4.card-title.mb-0
          | Interaction
          small  with {{name}} &nbsp;
          button.btn.btn-success(v-if="sentimentValue >= 0")
            span {{sentiment}} &nbsp;
            span.fa.fa-thumbs-o-up
          button.btn.btn-secondary(v-else-if="sentimentValue == '-'")
            span {{sentiment}} &nbsp;
            span
          button.btn.btn-danger(v-else="sentimentValue < 0")
            span {{sentiment}} &nbsp;
            span.fa.fa-thumbs-o-down
        div.small.text-muted
          | Displaying past interactions with {{name}}
      //- div.col-sm-7.hidden-sm-down
        b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br

    div(v-if='loading')
      | Loading Chat...
      br
      br
    div(v-else)
      div(v-if='loadingMore', style='margin: 10px 0px; text-align: center;')
        i.fa.fa-refresh.fa-spin
      div(style="margin: 10px 0px; text-align: center; text-decoration: underline; color: #0084ff; cursor: pointer;", @click="addNoOfChats", v-else-if="maxChatsNotReached")
        | View older messages...
      app-chat(v-if='!screenFull', :msgs='chats', :profPic='profPicUrl', :botPic='avatarURL', :takeover='paused', :duplicateAgent='duplicateAgent', :onlineStatus='onlineStatus')
    //- division for video call
    div(v-if='videoIsOn' class="video-window", :class='{fullscreen: screenFull}')
      video(class="friendVideoCalling", :class='{fullscreen: screenFull}' id="friendsVideo" autoplay playsinline)
      video(class="yourVideoCalling", :class='{fullscreen: screenFull}' id="yourVideo" autoplay playsinline)
      br
      button(v-on:click="toggleFullscreen" type="button" class="full", :class='{fullscreen: screenFull}')
       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 28.361 28.361" style="enable-background:new 0 0 28.361 28.361;" xml:space="preserve" width="14px" height="14px">
        <g>
          <g id="c115_arrows">
          <path d="M28.36,19.595c0-0.868-0.665-1.57-1.491-1.57c-0.819,0.002-1.492,0.702-1.492,1.57v3.25l-6.018-6.021    c-0.582-0.583-1.524-0.583-2.106,0c-0.582,0.582-0.582,1.527,0,2.109l5.989,5.987h-3.235c-0.881,0.002-1.591,0.669-1.591,1.491    c0,0.824,0.71,1.49,1.591,1.49h6.761c0.881,0,1.59-0.665,1.593-1.49c-0.003-0.022-0.006-0.039-0.009-0.061    c0.003-0.028,0.009-0.058,0.009-0.087v-6.668H28.36z" fill="#000000"/>
          <path d="M9,16.824l-6.015,6.021v-3.25c0-0.868-0.672-1.568-1.493-1.57c-0.824,0-1.49,0.702-1.49,1.57L0,26.264    c0,0.029,0.008,0.059,0.01,0.087c-0.002,0.021-0.006,0.038-0.008,0.061c0.002,0.825,0.712,1.49,1.592,1.49h6.762    c0.879,0,1.59-0.666,1.59-1.49c0-0.822-0.711-1.489-1.59-1.491H5.121l5.989-5.987c0.58-0.582,0.58-1.527,0-2.109    C10.527,16.241,9.584,16.241,9,16.824z" fill="#000000"/>
          <path d="M19.359,11.535l6.018-6.017v3.25c0,0.865,0.673,1.565,1.492,1.568c0.826,0,1.491-0.703,1.491-1.568V2.097    c0-0.029-0.006-0.059-0.009-0.085c0.003-0.021,0.006-0.041,0.009-0.062c-0.003-0.826-0.712-1.491-1.592-1.491h-6.761    c-0.881,0-1.591,0.665-1.591,1.491c0,0.821,0.71,1.49,1.591,1.492h3.235l-5.989,5.987c-0.582,0.581-0.582,1.524,0,2.105    C17.835,12.12,18.777,12.12,19.359,11.535z" fill="#000000"/>
          <path d="M5.121,3.442h3.234c0.879-0.002,1.59-0.671,1.59-1.492c0-0.826-0.711-1.491-1.59-1.491H1.594    c-0.88,0-1.59,0.665-1.592,1.491C0.004,1.971,0.008,1.991,0.01,2.012C0.008,2.038,0,2.067,0,2.097l0.002,6.672    c0,0.865,0.666,1.568,1.49,1.568c0.821-0.003,1.493-0.703,1.493-1.568v-3.25L9,11.535c0.584,0.585,1.527,0.585,2.11,0    c0.58-0.581,0.58-1.524,0-2.105L5.121,3.442z" fill="#000000"/>
          </g>
            <g id="Capa_1_253_">
            </g>
          </g>
        </svg>
      button(v-on:click="showFriendsFace" type="button" class="btn btn-primary btn-lg", :class='{fullscreen: screenFull}')
        span(class="glyphicon glyphicon-facetime-video" aria-hidden="true")
          | Call client
    form
      b-input-group
        b-form-input(v-model='msg.content', :disabled='duplicateAgent')
        div.autocomplete(style="position: absolute; bottom: 36px; width: 100%; color: #3e515b; background: white; font-size: 0.875rem;")
          div.autocomplete-item(v-for="item in autocompleteItems", v-if="msg.content !== item.item.title", @click="autocompleteInput(item.item.title)", style="padding: 0 13px; line-height: 2; height: 2.5em;")
            | {{ item.item.title }}
        b-input-group-button(slot='left', v-if='flagged')
          b-button.btn(type='button', :variant='countdown < 10 ? "danger" : "success"', v-b-tooltip.hover='"Countdown"', disabled)
            i.fa.fa-clock-o
            | &nbsp;{{countdown}}
        b-input-group-button(slot='right')
          b-button.btn(v-if='!videoIsOn', type='button', variant='secondary', @click='initializeVideocall', v-b-tooltip.hover='"Start Video Call"', :disabled='duplicateAgent')
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="videoIcon" x="0px" y="0px" viewBox="0 0 41.76 41.76" style="enable-background:new 0 0 41.76 41.76;" xml:space="preserve" width="14px" height="14px">
                <g>
                  <path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                  <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                </g>
                </svg>
          b-button.btn(v-if='videoIsOn', type='button', variant='success', @click='initializeVideocall', v-b-tooltip.hover='"Stop Video Call"', :disabled='duplicateAgent')
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" class="videoIcon" x="0px" y="0px" viewBox="0 0 41.76 41.76" style="enable-background:new 0 0 41.76 41.76;" xml:space="preserve" width="14px" height="14px">
                <g>
                  <path d="M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                  <path d="M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z" fill="#ffffff" stroke="#ffffff" stroke-width="3"/>
                </g>
                </svg>
          b-button.btn(type='button', variant='danger', v-if='!paused', @click='pause', v-b-tooltip.hover='"Pause Chatbot"', :disabled='duplicateAgent')
            i.icon-control-pause
          b-button.btn(type='button', variant='success', v-if='paused', @click='pause', v-b-tooltip.hover='"Unpause Chatbot"', :disabled='duplicateAgent')
            i.icon-control-play
          b-button.btn.text-white(type='submit', variant='secondary', @click='sendMessage', v-b-tooltip.hover='sending ? "Sending Message" : "Send Message"', :disabled='!msg.content || (flagged && duplicateAgent)')
            i.fa.fa-refresh.fa-spin(v-if='sending')
            i.icon-paper-plane(v-else)

</template>

<script>
import { db, metadb } from '@/firebase'
import { send, blast, cancelCountdown, getCountdown } from '@/api'
import { Carousel, Slide } from 'vue-carousel'
import Fuse from 'fuse.js'
// fuseOptions with decent balance of fuzzy search
import FUSE_OPTIONS from '../InteractionFolder/fuseOptions'
import FUZZY_SEARCH_ITEMS from '../InteractionFolder/fuzzySearchItems'

const fuse = new Fuse(FUZZY_SEARCH_ITEMS, FUSE_OPTIONS)

const bots = metadb.ref('bots')
const chatRef = db.ref('chats')
const usersRef = db.ref('users')
const flagRef = db.ref('flags')
const msgsRef = db.ref('newestChats')
const videoRef = db.ref('videoCalling')

export default {
  name: 'dashboard',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      usersCount: 0,
      name: null,
      sentiment: '-',
      sentimentValue: '-',
      loading: true,
      profPicUrl: 'static/img/avatars/0.png',
      pageID: this.$route.params.userId,
      chats: [],
      msg: {
        content: '',
      },
      paused: false,
      onlineStatus: 'danger',
      sending: false,
      avatarURL: null,
      countdown: 999,
      dTimer: null,
      flagged: false,
      currentUser: this.$store.state.profile.firstName, // agent profile
      duplicateAgent: false,
      newestKey: null,
      flagKey: null,
      firstSendObj: {},
      firstNameOfAgent: this.$store.state.profile.firstName,
      uniqueIDOfAgent: this.$store.state.profile.uniqueID,
      cdSync: false,
      noOfChats: 1,
      firstChatID: '',
      clickedOnLoadMore: false,
      maxChatsNotReached: true,
      loadingMore: false,
      pc: null,
      screenFull: false,
      videoIsOn: false,
      autocompleteItems: [],
    }
  },
  watch: {
    flagged() {
      // THIS IS CHANGED
      if (this.flagged) {
        const self = this
        this.dTimer = setInterval(function() {
          if (self.msg.content && !self.cdSync) {
            getCountdown(self.pageID, self.flagKey)
              .then((jsonObj) => {
                // Extend the timeleft to server time
                const timeLeft = jsonObj.body
                if (jsonObj.statusCode !== 400 && timeLeft !== 0 && self.firstSendObj[self.pageID] === false) {
                  self.countdown = timeLeft
                  self.cdSync = true
                }
              })
          } else if (self.msg.content == '') {
            self.cdSync = false
          }
          --self.countdown
          if (self.countdown <= 0) {
            clearInterval(self.dTimer)
            self.navigation()
            // remove agent
            flagRef.child(self.flagKey + '/agent').remove()
          }
        }, 1000)
      }
    },
    'msg.content': function(val, oldVal) {
      this.generateAutocompleteItems(val)
    },
  },
  mounted: function() {
    function fullNameElseID(key, val) {
      if (val.firstName && val.lastName) {
        return val.firstName + ' ' + val.lastName
      } else if (val.name) {
        return val.name
      } else if (val.shortID) {
        return 'Guest ' + val.shortID
        // this is short key
        // return val.shortID
      } else {
        return 'Guest'
        // this is long key
        // return key
      }
    }
    const self = this
    bots.child(this.$store.state.bot).once('value').then((snapshot) => {
      this.avatarURL = snapshot.child('avatarURL').val()
    })
    flagRef.orderByChild('userID').equalTo(this.pageID).on('value', function(snapshot) {
      // THIS IS CHANGED
      if (snapshot.exists() && self.$router.currentRoute.name === 'Interaction') {
        self.flagged = true
        self.flagKey = Object.keys(snapshot.val())[0]
        // [KEVIN help check if this like works]
        if (snapshot.child(self.flagKey + '/agent').exists()) {
          if (snapshot.child(self.flagKey).val().agent != self.currentUser && self.currentUser != null) {
            self.duplicateAgent = true
          } else {
            self.duplicateAgent = false
          }
        } else {
          flagRef.child(self.flagKey).update({
            agent: self.currentUser,
          })
        }

        // if there's flag, sync timer
        getCountdown(self.pageID, self.flagKey)
          .then((jsonObj) => {
            // if it went through and the timer is NOT 0,
            // countdown would be 30 seconds OR
            // the remaining of the redis timer
            // if it's <30 seconds
            const timeLeft = jsonObj.body
            // TODO: the timeLeft check below could produce a bug
            // (when timeLeft IS 0)
            if (JSON.parse(window.localStorage.getItem('firstSendObj')) === null) {
              window.localStorage.setItem('firstSendObj', JSON.stringify(self.firstSendObj))
            }
            self.firstSendObj = JSON.parse(window.localStorage.getItem('firstSendObj'))
            if (self.firstSendObj.hasOwnProperty(self.pageID) === false) {
              self.firstSendObj[self.pageID] = true
              window.localStorage.setItem('firstSendObj', JSON.stringify(self.firstSendObj))
            }
            if (jsonObj.statusCode !== 400 && timeLeft !== 0 && self.firstSendObj[self.pageID] === false) {
              self.countdown = timeLeft
            }
          })
      }
    })
    usersRef.child(this.pageID).on('value', (snapshot) => {
      this.name = fullNameElseID(this.pageID, snapshot.val())
      if (snapshot.val().totalSentiment) {
        this.sentiment = `${Math.round(snapshot.val().totalSentiment.score * 100)}%`
        this.sentimentValue = Math.round(snapshot.val().totalSentiment.score * 100)
        if (Number.isNaN(this.sentimentValue)) { this.sentimentValue = '-' }
      }
      this.paused = snapshot.val().takeover
      this.newestKey = snapshot.val().newestChatKey
      this.onlineStatus = snapshot.val().status
    })
    this.displayChat(this.noOfChats)
    document.querySelector('button[type=submit]').addEventListener('submit', (e) => {
      e.preventDefault()
    })
    document.getElementsByTagName('form')[0].addEventListener('submit', (e) => {
      e.preventDefault()
    })
    // recordDataLog('visitInteraction', `${this.pageID}`, {
    //   agentID: this.$store.state.profile.uniqueID,
    // })
  },
  beforeDestroy: function() {
    // this condition is to prevent the clock from showing in the ui after 300 seconds is over
    // it happens when the agent stays in the page after sending a message.
    if (this.flagged) {
      getCountdown(this.pageID, this.flagKey)
        .then((jsonObj) => {
          // check if the timeleft is zero or less
          const timeLeft = jsonObj.body
          if (jsonObj.statusCode !== 400 && timeLeft <= 0) {
            this.flagged = false
            delete this.firstSendObj[this.pageID]
            localStorage.setItem('firstSendObj', JSON.stringify(this.firstSendObj))
          }
        })
    }
    clearInterval(this.dTimer)
    flagRef.child(this.flagKey + '/agent').remove()
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      /* if (window.pageYOffset == 0 && this.maxChatsNotReached == true) {
        this.addNoOfChats()
      } */
    },
    toggleFullscreen: function() {
      this.screenFull = !this.screenFull
    },
    displayChat(noOfChats) {
      var icPattern = /\d{2}[0-1]\d{1}[0-3]\d{1}-?\d{2}-?\d{4}/
      var cdsPattern = /\d{10}/
      chatRef.off('value')
      var chats
      chatRef.child(this.pageID + '/chats').orderByChild('timestamp').limitToLast(noOfChats * 10).on('value', (snapshot) => {
        chats = []
        Object.entries(snapshot.val()).forEach(
          function([key, val]) {
            // To display all messages in the interaction page.
            // check if it's an array.
            // if it is then there is multiple message and need to account if it is stored in the text or quickreply title.
            // else it is just a string which is query from users.
            let chat = {
              chatID: key,
              fromUser: val.fromUser,
              message: val.message,
              translatedText: null,
              dashboard: val.matchedIntent == 'N/A from Dashboard',
              timestamp: val.timestamp,
              platform: val.platform,
              sentiment: `${Math.round(val.sentiment * 100)}%`,
              sentimentValue: val.sentiment,
              agent: val.agent && val.agent.name,
            }
            if (Array.isArray(val.message)) {
              try {
                Object.entries(val.message).forEach(function(element) {
                  let chatLocal = Object.assign({}, chat) // prevent value reference during loop
                  // pure text messages
                  if (element[1].text) {
                    chatLocal.message = element[1].text.text[0]
                    chats.push(chatLocal)
                  // quickReplies messages for FB
                  } else if (chat.platform.source == 'fb' && element[0].quickReplies) {
                    // create array before sending for uniform acceptance in chat.vue component by Bear Bear
                    var fbQuickRepliesArray = []
                    fbQuickRepliesArray.push(element[0].quickReplies)
                    chatLocal.message = fbQuickRepliesArray
                    chats.push(chatLocal)
                  // quickReplies messages
                  } else if (element[1].quickReplies) {
                    // create array before sending for uniform acceptance in chat.vue component by Bear Bear
                    var quickRepliesArray = []
                    quickRepliesArray.push(element[1].quickReplies)
                    chatLocal.message = quickRepliesArray
                    chats.push(chatLocal)
                  // payload for carousel
                  } else if (element[1].payload) {
                    // generic template
                    if (element[1].payload.facebook.attachment.payload.template_type == 'generic') {
                      // send the elements of carousel to chat.vue component by Bear Bear
                      const carouselElements = element[1].payload.facebook.attachment.payload.elements
                      chatLocal.message = carouselElements
                      chats.push(chatLocal)
                    } else if (element[1].payload.facebook.attachment.payload.template_type == 'list') {
                      // send the elements of list template to chat.vue component by Bear Bear
                      const templateElements = [
                        element[1].payload.facebook.attachment.payload,
                      ]
                      chatLocal.message = templateElements
                      chats.push(chatLocal)
                    } else {
                      // for future debug and add on
                      console.log('receiving payload but unknown format')
                    }
                  // payload for custom carousel
                  } else if (element[1][0].address) {
                    const carouselElements = element[1]
                    chatLocal.message = carouselElements
                    chats.push(chatLocal)
                  }
                })
              } catch (e) {
                console.log('error mou', e, val.message)
              }
            } else {
              if (val.message.search('&nbsp;') !== -1) {
                chat.message = val.message.replace('&nbsp;', ' ')
              }
              if (val.formattedAddress) {
                chat.message = val.formattedAddress
              }
              if (val.imageUrl) {
                chat.message = {
                  imageUrl: val.imageUrl,
                }
              }
              if (typeof chat.message == 'string') {
                chat.message = chat.message.split(icPattern).join('••••IC NO••••').split(cdsPattern).join('•••CDS••••')
              }

              chats.push(chat)
            }
          })
        this.chats = chats
        // console.log({chats})
        this.loading = false
        this.loadingMore = false
        if (this.clickedOnLoadMore == false) {
          setTimeout(function() { window.scrollTo(0, document.body.scrollHeight) }, 300) // Scrolls to bottom of chat
        } else {
          var firstChatID = this.firstChatID
          setTimeout(() => {
            var headerHeight = 70
            document.getElementById(firstChatID).scrollIntoView(true)
            var scrolledY = window.scrollY

            if (scrolledY) {
              window.scroll(0, scrolledY - headerHeight)
            }
          }, 100)
        }
        this.clickedOnLoadMore = false
        this.firstChatID = this.chats[0].chatID
      })
      chatRef.child(this.pageID + '/chats').once('value').then((snapshot) => {
        if (snapshot.numChildren() <= (this.noOfChats * 10)) {
          this.maxChatsNotReached = false
        }
      })
    },
    replaceNewline: function(innerHTML) {
      if (typeof innerHTML !== 'string') {
        return ''
      }
      return innerHTML.replace(/\n/g, '<br>')
    },
    addNoOfChats() {
      this.loadingMore = true
      this.noOfChats += 1
      this.clickedOnLoadMore = true
      this.displayChat(this.noOfChats)
    },
    triggersend(evt) {
      evt.preventDefault()
      this.$refs.myModalRef.hide()
      this.Sendconfirmation = true
    },
    hidemodal() {
      this.$refs.myModalRef.hide()
      this.Sendconfirmation = false
    },
    navigation() {
      this.$router.push('/interactionsRT')
      this.$snotify.error('Your page session has expired!')
    },
    sendMessage() {
      this.sending = true
      // const self = this
      var content = {
        // platform: 'webPopup',
        platform: this.chats[0].platform.source,
        userID: this.pageID,
        message: this.msg.content,
        // send details about agent (sendMsgByAgent)
        agentName: this.firstNameOfAgent,
        agentID: this.uniqueIDOfAgent,
      }
      // var content
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          if (this.flagged && this.firstSendObj[this.pageID] && this.msg.content !== undefined && /^\s*$/.test(this.msg.content)) {
            this.firstSendObj[this.pageID] = false
            window.localStorage.setItem('firstSendObj', JSON.stringify(this.firstSendObj))
            // TODO:
            // validate that the requests went through
            cancelCountdown(this.pageID).then(function (res) { console.log(res) })
          }
          // if (this.flagged) {
          //   resetFlagTime(this.pageID, this.flagKey).then(function (res) {
          //     console.log('cd reset', res)
          //     self.cdSync = false
          //     getCountdown(self.pageID, self.flagKey)
          //       .then((jsonObj) => {
          //         // Extend the timeleft to server time
          //         const timeLeft = jsonObj.body
          //         if (jsonObj.statusCode !== 400 && timeLeft !== 0) {
          //           self.countdown = timeLeft
          //           self.cdSync = true
          //         }
          //       })
          //   })
          // }
          this.sending = false
        }.bind(this))
      // handleFlaggedMessage(this.pageID, this.firstNameOfAgent)
      // recordDataLog('sendMessage', `${this.pageID}/${this.$store.state.profile.uniqueID}`, {
      //   message: content.message,
      // })
      this.$data.msg.content = ''
      document.getElementsByTagName('input')[0].value = ''
    },
    sendBlast() {
      var content = {
        platform: 'webPopup',
        campaignGroup: 'demo',
        campaign: this.msg.content,
      }
      // var content
      blast(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
        })
    },
    pause() {
      usersRef.child(this.pageID).update({
        takeover: !this.paused,
        flagged: false,
      })
      msgsRef.child(this.newestKey).once('value').then((snapshot) => {
        var t = snapshot.val().timestamp
        msgsRef.child(this.newestKey).update({
          timestamp: t + 1,
          flagged: false,
        })
      })
      // HERE IS CHANGED
      if (this.flagged && !this.paused) {
        flagRef.orderByChild('userID').equalTo(this.pageID).once('value', function(snapshot) {
          Object.entries(snapshot.val()).forEach(
            function([key, val]) {
              flagRef.child(key).remove()
            })
        })
        this.flagged = false
        delete this.firstSendObj[this.pageID]
        localStorage.setItem('firstSendObj', JSON.stringify(this.firstSendObj))
        clearInterval(this.dTimer)
        // cancel countdown
        // handleFlaggedMessage(this.pageID, this.firstNameOfAgent)
        cancelCountdown(this.pageID).then(function (res) { console.log(res) })
      }
      /* var content = {
        platform: 'fb',
        userID: this.pageID,
        message: 'A live agent just ' + (this.paused ? 'joined' : 'left') + ' the chat'
      }
      // console.log(content)
      send(content)
        .then(function (res) {
          res.error && this.$snotify.error(res.error)
          this.sending = false
        }.bind(this)) */
    },
    // video calling function
    initializeVideocall() {
      var that = this
      this.$data.videoIsOn = !this.$data.videoIsOn
      console.log('it run here initialize')
      if (this.$data.videoIsOn) {
        process.nextTick(function() {
          // var yourVideo = document.getElementById('yourVideo')
          var friendsVideo = document.getElementById('friendsVideo')
          var yourId = that.pageID
          that.$data.videoId = yourId
          // Create an account on Viagenie (http://numb.viagenie.ca/), and replace {'urls': 'turn:numb.viagenie.ca','credential': 'websitebeaver','username': 'websitebeaver@email.com'} with the information from your account
          var servers = { 'iceServers': [{ 'urls': 'stun:stun.services.mozilla.com' }, { 'urls': 'stun:stun.l.google.com:19302' }, { 'urls': 'turn:numb.viagenie.ca', 'credential': 'beaver', 'username': 'boringdragonlee@gmail.com' }] }
          var pc = new RTCPeerConnection(servers)
          that.$data.pc = pc
          pc.onicecandidate = event => event.candidate ? sendMessage(yourId, JSON.stringify({ 'ice': event.candidate })) : console.log('Sent All Ice')
          pc.onaddstream = event => { friendsVideo.srcObject = event.stream }
          videoRef.on('child_added', readMessage)
          that.showMyFace()
        })
      } else {
        if (that.screenFull) {
          that.screenFull = false
        }
        that.$data.pc.close()
      }

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data })
        msg.remove()
      }

      function readMessage(data) {
        var msg = JSON.parse(data.val().message)
        var sender = data.val().sender
        if (sender != that.$data.videoId) {
          if (msg.ice != undefined) {
            that.$data.pc.addIceCandidate(new RTCIceCandidate(msg.ice))
          } else if (msg.sdp.type == 'offer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
              .then(() => that.$data.pc.createAnswer())
              .then(answer => that.$data.pc.setLocalDescription(answer))
              .then(() => sendMessage(that.$data.videoId, JSON.stringify({ 'sdp': that.$data.pc.localDescription })))
          } else if (msg.sdp.type == 'answer') {
            that.$data.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
          }
        }
      }
    },
    showMyFace() {
      var yourVideo = document.getElementById('yourVideo')
      yourVideo.muted = 'muted'
      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then((stream) => {
          yourVideo.srcObject = stream
          return stream
        })
        .then(stream => {
          this.$data.pc.addStream(stream)
        })
    },
    showFriendsFace() {
      this.$data.pc.createOffer()
        .then(offer => this.$data.pc.setLocalDescription(offer))
        .then(() => sendMessage(this.$data.videoId, JSON.stringify({ 'sdp': this.$data.pc.localDescription })))

      function sendMessage(senderId, data) {
        var msg = videoRef.push({ sender: senderId, message: data })
        msg.remove()
      }
    },
    generateAutocompleteItems(input) {
      // TODO: don't generate again when the input is the same

      // only run the search if it's between 2 & 64 charas,
      // else, return blank results
      // also, limit it down to the top 5 results
      const results = (input.length > 1 && input.length <= 64) ? fuse.search(input).slice(0, 5) : []

      // TODO:
      // we can technically cache all the results

      // set the input to the latest used input
      // for generating autocompleteItems.
      // (this is so that generateAutocompleteItems can return early
      // if the next input is the same!)
      this.autocompleteItems = results
    },
    autocompleteInput(title) {
      this.msg.content = title
      this.autocompleteItems = []
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Interaction.vue?4ccb74c8